export const GET_COACHES = 'GET_COACHES';
export const GET_USER_COACH = 'GET_USER_COACH';
export const GET_PREVIOUS_COACH_PROFILE = 'GET_PREVIOUS_COACH_PROFILE';
export const GET_COACH_AVAILABILITY = 'GET_COACH_AVAILABILITY';
export const MATCH_COACH = 'MATCH_COACH';
export const GET_COACH = 'GET_COACH';
export const UPDATE_MATCHED_COACH = 'UPDATE_MATCHED_COACH';
